import prefixNamespace from '@/utils/prefix-namespace'
import { storeKeyNameSpace } from '@/constants/stores'

export const _types = {
    getters: {
        GET_SETTINGS: 'getPrefetchSettings'
    },
    actions: {
        GET_SETTINGS: 'getPrefetchSettings',
        SAVE_SETTINGS: 'savePrefetchSettings',
        GOOGLE_ANALYTICS_AUTH: 'googleAnalyticsAuth',
        DISCONNECT_GA: 'disconnectGA',
        CHOOSE_PROFILE: 'chooseProfile',
        GET_LIST_PROFILE: 'getListProfile'
    },
    mutations: {
        SET_PREFETCH_SETTINGS: 'setPrefetchSettings'
    }
}
export const types = prefixNamespace(`${storeKeyNameSpace.PRELOADING}/`, _types)